module.exports = __webpack_public_path__ + "media/images/result_sets/icons/learned_pdf-621f471b4e6179ecc95cd02d7657224d.svg";